import * as api from 'services/api';

export const setOpenDrawer = (open) => ({
  type: 'SET_OPEN_DRAWER',
  payload: open
});

export const setLocalSignInRedirect = (redirect) => ({
  type: 'SET_LOCAL_SIGN_IN_REDIRECT',
  payload: redirect
});

export const setUser = (user) => {
  return { type: 'SET_USER', payload: user };
};

export const ping = () => (dispatch) => api.get('auth', 'PING', dispatch);
